// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer20: FC<FastTimer20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M12.749 16c-1.666 0-3.082-.583-4.249-1.75-1.167-1.167-1.75-2.583-1.75-4.249 0-1.653.583-3.067 1.75-4.24C9.667 4.586 11.083 4 12.749 4c1.653 0 3.067.587 4.24 1.76 1.174 1.174 1.761 2.588 1.761 4.241 0 1.666-.587 3.082-1.76 4.249-1.174 1.167-2.588 1.75-4.241 1.75Zm-.01-1.5c1.257 0 2.323-.434 3.198-1.302.876-.868 1.313-1.93 1.313-3.188 0-1.257-.438-2.322-1.313-3.197C15.063 5.938 14 5.5 12.75 5.5c-1.264 0-2.33.438-3.198 1.313C8.684 7.688 8.25 8.75 8.25 10c0 1.264.434 2.33 1.302 3.198.868.868 1.93 1.302 3.188 1.302Zm1.72-1.708 1.062-1.063-2.023-2.027V7H12v3.318l2.458 2.474ZM2.5 7.5V6h3v1.5h-3Zm-1 3.25v-1.5h4v1.5h-4Zm1 3.25v-1.5h3V14h-3Z" />
        </svg>
    );
};

export default FastTimer20;
